import "./input-counter.scss";

import PropTypes from "prop-types";

/**
 * Numeric up/down counter input with a minimum value of 1.
 *
 * @param root0 - The component props.
 * @param root0.value - The current counter value.
 * @param root0.onChange - The change event handler.
 * @returns The rendered input counter.
 */
const InputCounter = ({ value = 1, onChange }) => {
    const upClick = () => {
        onChange(value + 1);
    };

    const downClick = () => {
        if (value > 1) {
            onChange(value - 1);
        }
    };

    let downButtonClasses = "input-counter-button";
    let downButtonColor = "#999";
    if (value > 1) {
        downButtonClasses = downButtonClasses + " active";
        downButtonColor = "#FFF";
    }

    return (
        <div className="input-counter">
            <button className={downButtonClasses} onClick={downClick}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="9"
                    viewBox="0 0 15 9"
                >
                    <path
                        fill="none"
                        fillRule="evenodd"
                        stroke={downButtonColor}
                        strokeLinecap="square"
                        strokeWidth="2"
                        d="M13.5 1.5l-6 6-6-6"
                    />
                </svg>
            </button>
            <div className="input-counter-input-container">
                <input
                    maxLength="2"
                    type="text"
                    value={value}
                    className="input-counter-input"
                    readOnly
                />
            </div>
            <button className="input-counter-button active" onClick={upClick}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="9"
                    viewBox="0 0 15 9"
                >
                    <path
                        fill="none"
                        fillRule="evenodd"
                        stroke="#FFF"
                        strokeLinecap="square"
                        strokeWidth="2"
                        d="M1.529 7.5l6-6 6 6"
                    />
                </svg>
            </button>
            <div className="input-counter-description">Move Distance (ft)</div>
        </div>
    );
};

InputCounter.propTypes = {
    value: PropTypes.number,
    onChange: PropTypes.func,
};

export default InputCounter;
